import script from "./FormulasPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./FormulasPreview.vue?vue&type=script&setup=true&lang=js"

import "./FormulasPreview.vue?vue&type=style&index=0&id=3766f867&lang=scss"

const __exports__ = script;

export default __exports__